import CryptoJS from "crypto-js";

const asecAgentData = (version) => {
  console.log(version);

  let tgmag = localStorage.getItem("agent") || "x7z1";

  let tgmudid = tgmag;

  if (localStorage.getItem("tgm_uuid")) {
    let key = "1234567890123456"; // 密钥长度需为16字节（128位）

    if (version == "v3") {
      key = "9917987690129917";
      let obj = {
        agent: tgmudid,
        brand:
          (localStorage.getItem("app") &&
            JSON.parse(localStorage.getItem("app"))?.brand) ||
          "9917",
        vid: localStorage.getItem("tgm_uuid"),
      };

      tgmudid = JSON.stringify(obj);
    } else {
      tgmudid = tgmudid + "~" + localStorage.getItem("tgm_uuid");
    }

    // 密钥和明文
    let plaintext = tgmudid;

    // 确保密钥长度为16字节
    key = CryptoJS.enc.Utf8.parse(key);

    // 加密数据
    let encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    // 转换为十六进制字符串（bin2hex 类似操作）
    let encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

    tgmudid = encryptedHex;
  } else {
    if (version == "v3") {
      let key = "9917987690129917";
      let obj = {
        agent: tgmudid,
        brand:
          (localStorage.getItem("app") &&
            JSON.parse(localStorage.getItem("app"))?.brand) ||
          "9917",
        vid: localStorage.getItem("key"),
      };

      tgmudid = JSON.stringify(obj);

      // 密钥和明文
      let plaintext = tgmudid;

      // 确保密钥长度为16字节
      key = CryptoJS.enc.Utf8.parse(key);

      // 加密数据
      let encrypted = CryptoJS.AES.encrypt(plaintext, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });

      // 转换为十六进制字符串（bin2hex 类似操作）
      let encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

      tgmudid = encryptedHex;
    }
  }

  return tgmudid;
};

export { asecAgentData };
